import './TableTraffic.css'

import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { FixedSizeList as List } from 'react-window'
import useSyncScroll from 'utils/useSyncScroll'

import TableTrafficHeader from './TableTrafficHeader'
import TableTrafficRow from './TableTrafficRow'

const TableTraffic = ({
  headerClassName,
  itemHeight,
  listHeight,
  maxTraffic,
  onFilter,
  onScroll,
  scrollOffset,
  showModal,
  sortBy,
  stores,
  type,
}) => {
  const listRef = useRef()

  useSyncScroll(listRef, scrollOffset)

  return (
    <div className="table-traffic">
      <TableTrafficHeader className={headerClassName} onFilter={onFilter} sortBy={sortBy} type={type} />

      <List
        useIsScrolling
        className="table-traffic-row"
        height={listHeight}
        itemCount={stores.length}
        itemData={{
          maxTraffic,
          showModal,
          stores,
          type,
        }}
        itemSize={itemHeight}
        onScroll={onScroll}
        overscanCount={8}
        ref={listRef}
        width="100%"
      >
        {TableTrafficRow}
      </List>
    </div>
  )
}

TableTraffic.propTypes = {
  headerClassName: PropTypes.string,
  itemHeight: PropTypes.number,
  listHeight: PropTypes.number,
  maxTraffic: PropTypes.number,
  onFilter: PropTypes.func,
  onScroll: PropTypes.func,
  scrollOffset: PropTypes.number,
  showModal: PropTypes.func,
  sortBy: PropTypes.object,
  stores: PropTypes.array,
  type: PropTypes.string,
}

export default TableTraffic
